function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: fixed;\n  z-index: 99999;\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  padding: 8px 24px;\n  background: ",
        ";\n  color: ",
        ";\n  font-size: 14px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  body {\n    padding: ",
        ";\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
import React from "react";
import styled, { createGlobalStyle } from "styled-components";
import { useWrContext } from "../../wr-context";
export var PreProdBanner = function() {
    var ref, ref1, ref2;
    var context = useWrContext();
    var ref3 = context.constants.preProd || {}, _isInPreProdMode = ref3.isInPreProdMode, isInPreProdMode = _isInPreProdMode === void 0 ? false : _isInPreProdMode, banner = ref3.banner;
    if (!isInPreProdMode) return null;
    return /*#__PURE__*/ React.createElement(Container, {
        className: "preProd-container",
        x: (banner === null || banner === void 0 ? void 0 : (ref = banner.position) === null || ref === void 0 ? void 0 : ref.x) || "full",
        y: (banner === null || banner === void 0 ? void 0 : (ref1 = banner.position) === null || ref1 === void 0 ? void 0 : ref1.y) || "bottom"
    }, (banner === null || banner === void 0 ? void 0 : banner.component) || /*#__PURE__*/ React.createElement(Content, null, "You are in pre-prod mode"), /*#__PURE__*/ React.createElement(GlobalStyles, {
        y: (banner === null || banner === void 0 ? void 0 : (ref2 = banner.position) === null || ref2 === void 0 ? void 0 : ref2.y) || "bottom"
    }));
};
var xMap = {
    center: "left: 50%; transform: translateX(-50%);",
    left: "left: 0; text-align: left;",
    right: "right: 0; text-align: left;",
    full: "left: 0; width: 100%; text-align: center;"
};
var yMap = {
    top: "top: 0;",
    bottom: "bottom: 0;"
};
var Container = styled.div(_templateObject(), function(props) {
    return xMap[props.x];
}, function(props) {
    return yMap[props.y];
});
var Content = styled.div(_templateObject1(), function(props) {
    return props.theme.palette.primary;
}, function(props) {
    return props.theme.palette.background;
});
var GlobalStyles = createGlobalStyle(_templateObject2(), function(props) {
    return props.y === "top" ? "32px 0 0 0" : "0 0 32px 0";
});
